<script setup lang="ts">
const show = ref(false)
let scrollFrame = 0

const updateVisible = () => {
  if (!import.meta.client) {
    return
  }
  if (scrollFrame) {
    return
  }
  scrollFrame = window.requestAnimationFrame(() => {
    scrollFrame = 0
    show.value = window.scrollY > 280
  })
}

const scrollToTop = () => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' })
}

onMounted(() => {
  updateVisible()
  window.addEventListener('scroll', updateVisible, { passive: true })
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', updateVisible)
  if (scrollFrame) {
    window.cancelAnimationFrame(scrollFrame)
    scrollFrame = 0
  }
})
</script>

<template>
  <Transition name="to-top-fade">
    <button v-if="show" type="button" class="to-top-btn" aria-label="返回顶部" @click="scrollToTop">
      <i class="fa-solid fa-arrow-up" aria-hidden="true" />
    </button>
  </Transition>
</template>

<style scoped>
.to-top-btn {
  position: fixed;
  right: 18px;
  bottom: 18px;
  z-index: 45;
  width: 42px;
  height: 42px;
  border: 0;
  border-radius: 999px;
  color: var(--text-soft);
  background: var(--floating-bg);
  box-shadow: var(--floating-shadow);
  cursor: pointer;
  transition:
    background-color 0.18s ease,
    transform 0.18s ease;
}

.to-top-btn:hover {
  background: var(--floating-button-hover-bg);
  transform: translateY(-3px);
}

.to-top-fade-enter-active,
.to-top-fade-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.to-top-fade-enter-from,
.to-top-fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

@media (max-width: 760px) {
  .to-top-btn {
    right: 12px;
    bottom: 12px;
    width: 40px;
    height: 40px;
  }
}
</style>
